module.exports = "<div class=\"ssrs-report-viewer\">\r\n  <iframe ng-if=\"initialized\" class=\"report-viewer-iframe\" id=\"ssrsReportViewerId\" [src]=\"getSanitizedUrl()\" aria-label=\"Iframe Report Viewer\" aria-hidden=\"false\"></iframe>\r\n  <div fxLayout=\"row\" fxLayoutAlign=\"center center\" class=\"loading-indicator\" *ngIf=\"loading\">\r\n    <mat-spinner></mat-spinner>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/components/ssrs-report-viewer.component.html
// module id = ./src/app/report/components/ssrs-report-viewer.component.html
// module chunks = main